import PropTypes from "prop-types";
import styled from "styled-components";
import resolveObjPath from "src/utils/resolve-path";

const propTypes = {
    svg: PropTypes.string.isRequired,
    logo: PropTypes.bool,
    fill: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    margin: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    pointer: PropTypes.bool,
};

const defaultProps = {
    fill: "currentColor",
    height: 20,
    width: 20,
    pointer: true,
};

export const getFill = ({ theme, fill, logo }) => {
    if (fill?.includes(".")) return resolveObjPath(theme, `${fill}`.split("."));
    if (logo) return theme.palette.text.primary;
    return fill || theme?.palette?.primary?.main;
};

const getHoverFill = ({ theme, fill, logo }) => {
    if (logo) return theme.palette.primary.main;
    if (fill?.includes(".")) return resolveObjPath(theme, `${fill}`.split("."));
    return fill || theme?.palette?.primary?.main;
};

const Icon = styled.span.attrs(({ svg }) => ({
    dangerouslySetInnerHTML: {
        __html: svg,
    },
}))`
    line-height: 0;
    vertical-align: ${(props) => props.verticalAlign};
    display: inline-block;
    margin: ${({ margin }) => margin && margin.join(" ")};

    > svg {
        fill: ${getFill};
        height: ${({ height }) => (typeof height === "string" ? height : `${height}px`)};
        width: ${({ width }) => (typeof width === "string" ? width : `${width}px`)};

        &:hover {
            fill: ${getHoverFill};
            cursor: ${({ pointer }) => (pointer ? "pointer" : "unset")};
        }
    }
`;

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default Icon;
